import { z } from 'zod';

export const orderRejectSchema = z.object({
  reasonReject: z.string().min(1, 'Vui lòng nhập lý do từ chối'),
});

export type OrderRejectFormValues = z.infer<typeof orderRejectSchema>;
